import { render, staticRenderFns } from "./tabOrderCar.vue?vue&type=template&id=b6437f16&"
import script from "./tabOrderCar.vue?vue&type=script&lang=js&"
export * from "./tabOrderCar.vue?vue&type=script&lang=js&"
import style0 from "./tabOrderCar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6437f16')) {
      api.createRecord('b6437f16', component.options)
    } else {
      api.reload('b6437f16', component.options)
    }
    module.hot.accept("./tabOrderCar.vue?vue&type=template&id=b6437f16&", function () {
      api.rerender('b6437f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/tabs/tabOrderCar.vue"
export default component.exports